var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"htmlShizWeb"}),_c('div',{staticStyle:{"height":"80px"}}),_c('div',{staticClass:"htmlShizMobile"})])}]

export { render, staticRenderFns }